import { has } from 'lodash';
import * as types from './types';
import { SubmitType } from '../../helpers';

const INITIAL_STATE = {
  data: [],
  fetchError: null,
  submitted: {
    success: false,
    type: SubmitType.Edit,
  },
  submitError: null,
  submitting: false,
  fetching: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CONTROL_INFO_TYPES_FETCHING:
      return {
        ...state,
        fetching: action.payload,
      };

    case types.CONTROL_INFO_TYPES_SUBMITTING:
      return {
        ...state,
        submitting: action.payload,
      };

    case types.CONTROL_INFO_TYPES_SUBMIT_SUCCESS:
      return {
        ...state,
        submitted: {
          success: true,
          type: action.payload,
        },
      };

    case types.CONTROL_INFO_GET_TYPES:
      return {
        ...state,
        data: action.payload.filter(caseType => caseType.Id > 0),
      };

    case types.CONTROL_INFO_TYPES_FETCH_ERROR:
      if (has(action.payload, 'response.data.Errors')) {
        const fetchError = action.payload.response.data.Errors[0];

        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message:
            'An error occurred while retrieving Household Categorical Types. Please try again',
        },
      };

    case types.CONTROL_INFO_TYPES_SUBMIT_ERROR:
      if (has(action.payload, 'response.data.Errors')) {
        const submitError = action.payload.response.data.Errors[0];

        return {
          ...state,
          submitError,
        };
      }

      return {
        ...state,
        submitError: {
          Title: 'Error',
          Message:
            'An error occurred while saving Household Categorical Types. Please try again',
        },
      };

    case types.CONTROL_INFO_TYPES_CLEAR_ERROR_SUCCESS:
      return {
        ...state,
        fetchError: null,
        submitError: null,
        submitted: {
          success: false,
          type: SubmitType.Edit,
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/householdCategoricalTypes/reducer.js